<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
  <div class="container-fluid">

    <div class="row">
      <div class="col" *ngIf="agentService.is_display_agent_register_component">
        <button mat-fab color="primary" (click)="showAgentRegister()">
          <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon>
        </button>
        <div *ngIf="agents.length == 0">
          <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [value]="value"
            style="margin-left: 44%;margin-top: 16%;">
          </mat-progress-spinner>
        </div>
        <table class="table table-bordered table-hovered" *ngIf="agents.length != 0" style="    margin-top: 20px;">
          <tr>
            <th scope="col" style="width: 12%;">
              Agent Code
              <input matInput type="text" #filter
                style="    border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
            </th>
            <!-- <th scope="col">Sl.No</th> -->
            <th scope="col" style="width: 20%;">
              First Name
              <input matInput type="text" #first_name_filter
                style="    border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
            </th>
            <th scope="col">
              Booth Code
              <input matInput type="text" #booth_code_filter
                style="    border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
            </th>
            <th scope="col">
              Booth Type
              <input matInput type="text" #booth_type_filter
                style="    border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
            </th>
            <th scope="col" style="    width: 15%;">
              Mobile
              <input matInput type="text" #mobile_filter
                style="    border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
            </th>
            <th scope="col" style="    width: 15%;">
              Zone
              <input matInput type="text" #zone_filter
                style="    border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
            </th>
            <th scope="col">Gender</th>
            <th scope="col">Adhaar</th>
            <th scope="col">Image</th>
            <th scope="col">Edit</th>
          </tr>
          <tr
            *ngFor="let agent of agents | agentCodeFilter: filter.value | agentFirstnameFilter: first_name_filter.value | boothTypeFilter: booth_type_filter.value |boothCodeFilter: booth_code_filter.value | agentMobileFilter: mobile_filter.value | agentZoneFilter: zone_filter.value; let i = index">
            <th scope="row">{{agent['agent_code']}}</th>
            <!-- <td>{{i + 1}}</td> -->
            <td>{{agent['first_name']}}</td>
            <td>{{agent['business_code']}}</td>
            <td>{{agent['business_type']}}</td>
            <td>{{agent['mobile']}}</td>
            <td>{{agent['zone_name']}}</td>
            <td>{{agent['gender']}}</td>
            <td><button mat-raised-button (click)="openDialog(agent['agent_id'], 'adhaar_image')">View</button></td>
            <td><button mat-raised-button (click)="openDialog(agent['agent_id'], 'agent_image')">View</button></td>
            <td><button mat-icon-button (click)="editAgent(agent['agent_code'])">
                <mat-icon>edit</mat-icon>
              </button></td>
          </tr>
        </table>
      </div>

      <div class="col-12" *ngIf="!agentService.is_display_agent_register_component">
        <div class="row">
          <div class="col"></div>
          <div class="col-1">
            <button mat-fab color="primary" (click)="hideAgentRegister()">
              <i class="material-icons">
                clear
              </i>
            </button>
          </div>
        </div>
        <app-agent-booth-register></app-agent-booth-register>
      </div>


      <!-- <div class="row">
          <div class="col" *ngIf="!agentService.is_display_agent_register_component">
            <div class="row">
              <div class="col"></div>
              <div class="col-1">
                <button mat-fab color="primary" (click)="hideAgentRegister()">
                  <i class="material-icons">
                    clear
                  </i>
                </button>
              </div>
            </div>
            <app-agent-register></app-agent-register>
          </div>
        </div>
        <div class="row">
          <div class="col" *ngIf="!agentService.is_display_agent_register_component">
            <div class="row">
              <div class="col"></div>
              <div class="col-1">
                <button mat-fab color="primary" (click)="hideAgentRegister()">
                  <i class="material-icons">
                    clear
                  </i>
                </button>
              </div>
              <app-agent-booth-register></app-agent-booth-register>
            </div> -->
      <!-- <app-agent-register></app-agent-register> -->
    </div>
  </div>
  </div>
  <!-- <div *ngIf="dataSource == null">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [value]="value"
        style="margin-left: 44%;margin-top: 16%;">
      </mat-progress-spinner>
    </div> -->
</section>
